import { OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/adminPanel";
const truckingBidsResource = "api/truckingBids";
const queueQuery = { orderBy: ["id desc"] as [string] };

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...queueQuery });
    return request(`${resource}/getCalculationQueue${query}`, { method: "GET" }, { countInHeaders: true });
};

const apply = (params: {}) => {
    return alertRequest(`${truckingBidsResource}/addToRecalculation`, body(params));
};

export { index, apply };
